import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Form, Button, Message } from "semantic-ui-react";
import { createRetailer } from "../../firebase";

const Presets = ({ retailer, id }) => {
  const [presets, setPresets] = useState();
  const [defaultPresets, setDefaultPresets] = useState();
  const [showMessage, setShowMessage] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (retailer.templates[id].colorPresets) {
      const initialPresets = retailer.templates[id].colorPresets.join("\n");
      setPresets(initialPresets);
      setDefaultPresets(initialPresets);
    }
  }, [retailer, id]);

  const handleChange = (e, { name, value }) => {
    setPresets(value);
  };

  const handleSubmit = async () => {
    setShowLoading(true);
    let presetValues = presets.replace(/\n/g, ",").replace(/\s+/g, "");
    presetValues = presetValues.split(",");
    presetValues = _.remove(presetValues, (item) => {
      return item.length > 0;
    });
    const update = { ...retailer };
    update.templates[id].colorPresets = presetValues;
    createRetailer(update).then(() => {
      setShowLoading(false);
      setShowMessage(true);
      setDefaultPresets(presets);
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.TextArea
        label="Color picker presets"
        placeholder="Add each hex value on a new line"
        onChange={handleChange}
        value={presets}
        rows="15"
      />
      {showMessage && (
        <Message
          positive
          onDismiss={() => setShowMessage(false)}
          content="Presets have been updated"
        />
      )}
      <Button
        loading={showLoading}
        disabled={presets === defaultPresets}
        size="mini"
        positive
      >
        Submit
      </Button>
    </Form>
  );
};

export default Presets;
